import React from "react";
import PageHeader from "../components/PageHeader";

export default function JuvenileJustice() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Documents", link: "/documents" },
    { label: "Juvenile Justice Guidelines", active: true },
  ];

  const documents = [
    {
      title: "A GUIDE FOR DISTRICT ADMINISTRATION FOR IMPLIMENTATION OF JUVENILE JUSTICE ACT 2015 AND POCSO ACT 2012",
      size: "5.17 MB",
      date: "11-07-22",
      link: "#",
    },
    {
      title: "GUIDELINES FOR CHILD AND ADOLESCENT PARTICIPATION IN THE ENTERTAINMENT INDUSTRY AND ANY COMMERCIAL ENTERTAINMENT ACTIVITY",
      size: "1.13 MB",
      date: "18-05-23",
      link: "#",
    },
    {
      title: "GUIDELINES TO REGULATE CHILD PARTICIPATION IN TV SERIALS, REALITY SHOWS AND ADVERTISEMENTS",
      size: "920.08 KB",
      date: "19-05-23",
      link: "#",
    },
    {
      title: "GUIDELINES FOR CONDUCTING PRELIMINARY ASSESSMENT UNDER SECTION 15 OF THE JUVENILE JUSTICE (JJ) ACT, 2015",
      size: "1.07 MB",
      date: "13-04-23",
      link: "#",
    },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="Juvenile Justice Guidelines (NCPCR, Govt. of India)"
        breadcrumbs={breadcrumbs}
      />

      {/* Timeline Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-primary fw-bold mb-5 text-center">
            Juvenile Justice Guidelines
          </h2>

          <div className="position-relative">
            {/* Center line */}
            <div
              className="position-absolute top-0 start-50 translate-middle-x bg-primary"
              style={{ width: "4px", height: "100%", borderRadius: "2px" }}
            ></div>

            {/* Timeline items */}
            <div className="timeline position-relative">
              {documents.map((doc, index) => (
                <div
                  key={index}
                  className={`row g-0 mb-5 align-items-center ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="card shadow-sm p-4 rounded-4 border-0 timeline-card">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="badge bg-primary rounded-pill">
                          {index + 1}
                        </span>
                        <small className="text-muted">{doc.date}</small>
                      </div>
                      <h5 className="text-primary fw-bold mb-2">{doc.title}</h5>
                      <p className="text-secondary mb-3">{doc.size}</p>
                      <a
                        href={doc.link}
                        className="btn btn-outline-primary rounded-pill"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
